import React from 'react';

import { DescriptionList, DescriptionItem } from '@gogame/components';

const Metadata = ({ data = {} }) => {
  return (
    <DescriptionList
      variant={'column'}
      data={data}
      stripEmpty={true}
      disableGutters={true}
    >
      <DescriptionItem label={'Owner'} field={'owner'} />
      <DescriptionItem
        label={'Last updated by'}
        field={'metadata'}
        type={'metadata'}
        userField={'lastUpdatedBy'}
        dateField={'lastUpdatedDate'}
      />
      <DescriptionItem
        label={'Created by'}
        field={'metadata'}
        type={'metadata'}
        userField={'createdBy'}
        dateField={'createdDate'}
      />
    </DescriptionList>
  );
};

export default Metadata;
